import { ReloadOutlined, SearchOutlined } from '@ant-design/icons';
import { css } from '@emotion/react';
import {
    Button,
    Col,
    Collapse,
    CollapseProps,
    Form,
    Input,
    Row,
    Select,
    Typography
} from 'antd';
import {
    getListGroupFood,
    getListMaterialFood,
} from '@/redux/slices/food.slice';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { useEffect } from 'react';

import {
    watchListDishAge,
    watchListDishCookingMethod,
    watchListSourceDish,
    watchListStructureMealDish,
    watchListRegionDish,
} from '@/redux/slices/dish.slice';

import {
    watchNutritionalMenuCalculatorDishLoading
} from '@/redux/slices/nutritional-menu-calculator.slice';

export const AddDishesSearcher = ({
    handleSearch
}: {
    handleSearch: (values: FilterDishNutritionalMenuCalculator) => void;
}) => {
    const [form] = Form.useForm();
    const dispatch = useAppDispatch();
    const listRegion = useAppSelector(watchListRegionDish);
    const listDishAge = useAppSelector(watchListDishAge);
    const listDishCookingMethod = useAppSelector(watchListDishCookingMethod);
    const listSourceDish = useAppSelector(watchListSourceDish);
    const listStructureMealDish = useAppSelector(watchListStructureMealDish);
    const loading = useAppSelector(watchNutritionalMenuCalculatorDishLoading);

    const ageDishGroupOptions = listDishAge.map((item) => ({
        value: item.id,
        label: item.name
    }));

    const dishCookingMethodGroupOptions = listDishCookingMethod.map((item) => ({
        value: item.id,
        label: item.name
    }));

    const sourceDishGroupOptions = listSourceDish.map((item) => ({
        value: item.id,
        label: item.name
    }));

    const structureMealDishGroupOptions = listStructureMealDish.map((item) => ({
        value: item.id,
        label: item.name
    }));

    const regionDishGroupOptions = listRegion.map((item) => ({
        value: item.regionId,
        label: item.regionName
    }));

    const onSearchSearch = async () => {
        const values = form.getFieldsValue();
        handleSearch(values);
    }

    const handleClear = () => {
        form.resetFields();
    };

    useEffect(() => {
        dispatch(getListMaterialFood());
        dispatch(getListGroupFood());
    }, [dispatch]);

    const items: CollapseProps['items'] = [
        {
            key: '1',
            label: (
                <Typography.Title css={titleStyles} level={5}>
                    Chọn đối tượng xây dựng thực đơn
                </Typography.Title>
            ),
            children: (
                <Form
                    form={form}
                    css={formStyles}
                    layout="horizontal"
                    labelCol={{ span: 8 }}
                    wrapperCol={{ span: 16 }}
                >
                    <Row gutter={24} align='stretch'>
                        <Col span={12} css={filterItem}>
                            <Form.Item
                                label='Tên món ăn'
                                name='name'
                                css={customLabel}
                            >
                                <Input placeholder='Nhập từ khóa tìm kiếm món ăn' />
                            </Form.Item>
                        </Col>
                        <Col span={12} css={filterItem}>
                            <Form.Item
                                label='Độ tuổi (Đối tượng)'
                                name='age_group_ids'
                                css={customLabel}
                            >
                                <Select
                                    mode="multiple"
                                    showSearch
                                    optionFilterProp="children"
                                    style={{ width: '100%' }}
                                    options={ageDishGroupOptions}
                                />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={24} align='stretch'>
                        <Col span={12} css={filterItem}>
                            <Form.Item
                                label='Nguồn món ăn'
                                name='external_dish_type_ids'
                                css={customLabel}

                            >
                                <Select
                                    mode="multiple"
                                    options={sourceDishGroupOptions} />
                            </Form.Item>
                        </Col>
                        <Col span={12} css={filterItem}>
                            <Form.Item
                                label='Miền'
                                name='region_ids'
                                css={customLabel}
                            >
                                <Select
                                    mode="multiple"
                                    options={regionDishGroupOptions} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={24} align='stretch'>
                        <Col span={12} css={filterItem}>
                            <Form.Item
                                label='Nhóm món ăn theo cấu trúc bửa ăn'
                                name='meal_structure_ids'
                                css={customLabel}
                            >
                                <Select
                                    mode="multiple"
                                    options={structureMealDishGroupOptions} />
                            </Form.Item>
                        </Col>
                        <Col span={12} css={filterItem}>
                            <Form.Item
                                label='Nhóm món ăn theo phương pháp nấu'
                                name='cooking_method_ids'
                                css={customLabel}
                            >
                                <Select
                                    mode="multiple"
                                    options={dishCookingMethodGroupOptions} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row
                        gutter={16}
                        align='middle'
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            marginTop: '1rem'
                        }}
                    >
                        <Button
                            type='default'
                            icon={<ReloadOutlined />}
                            css={resetButton}
                            onClick={handleClear}
                        >
                            Đặt lại
                        </Button>
                        <Button
                            type='primary'
                            icon={<SearchOutlined />}
                            css={searchButton}
                            onClick={onSearchSearch}
                            loading={loading}
                        >
                            Tìm kiếm
                        </Button>
                    </Row>
                </Form>
            )
        }
    ];
    return (
        <Row css={boxStyles} justify='space-between' align='middle'>
            <Collapse
                items={items}
                defaultActiveKey={'1'}
                expandIconPosition={'end'}
                css={collapseStyles}
            />
        </Row>
    );
};

const boxStyles = css`
  padding: 0 1rem;
  background: var(--white-color);
  &:nth-of-type(2) {
    padding: 1.6rem 1rem;
  }
`;

const collapseStyles = css`
  width: 100%;
  border: none !important;
  padding: 0 !important;
  margin: 0 !important;
  background-color: transparent !important;

  .ant-collapse-header {
    width: fit-content;
    border-radius: 0.8rem !important;
    border: none !important;
    padding: 0 !important;

    .ant-collapse-expand-icon {
      align-self: center;
    }
  }

  .ant-collapse-content-box {
    padding: 0 !important;
  }

  .ant-collapse-content {
    border: none !important;
  }
`;

const titleStyles = css`
  margin-bottom: 0 !important;
  line-height: 3.2rem !important;
  font-weight: 700 !important;
`;

const formStyles = css`
  margin-top: 0.5rem;
  padding: 1rem;

  
`;

const filterItem = css`
  display: flex;
  justify-content: start !important;
  gap: 0.5rem;

  label {
    height: 100% !important;
  }

  .ant-form-item-label {
    width: fit-content;
    max-width: 33.33%;
    text-align: start !important;
    white-space: normal;
    font-size: 14px !important;
    font-weight: 500;
    word-wrap: break-word;
    word-break: break-word;
  }

  input,
  .ant-select,
  .ant-picker {
    flex: 1;
    min-width: 6rem;
  }

  .ant-form-item-control-input-content>.ant-input {
    height: auto !important;
    font-size: 14px !important;
  }

  .ant-form-item-control {
    justify-content: center !important
  }
`;

const customLabel = css`
  .ant-form-item-label > label {
    font-weight: normal !important;

    &::after,
    &::before {
      display: none !important;
    }

    margin: 0 2rem 0 0 !important;
  }

  width: 100%;
  margin-bottom: 0;
`;

const resetButton = css`
  margin-right: 10px;
  color: #007bff;
  border-color: #007bff;
`;

const searchButton = css`
  background: #007bff;
  color: white;
  &:hover {
    background: #0056b3;
  }
`;
